let mapOpenInfoWindow;

/**
 * Fonction appeler par Google Map qu'on utilise ensuite pour initialiser nos map.
 * Le Map par défaut est créer avec initDefaultMap() mais on a la possibilité d'en créer d'autre custom et les appeler dans cette fonction initMap()
 * */
function initMap() {
  if (typeof initDefaultMap === "function") {
    initDefaultMap();
  }
}

// Expose the init callback globally for the Google Maps API
if (typeof window !== 'undefined') {
  window.initMap = initMap;
}

/** Configuration de la Map par défaut */
function initDefaultMap() {
  const maps = document.querySelectorAll('.google-map');
  maps.forEach((mapElm) => {
    const map = configMap(mapElm);
    /** Ajouter les marqueurs à la carte avec l'icône personnalisée */
    const markers = setMarkers(map, mapElm);
  })
}

/** Récupérer les données des marqueurs */
function getMapMarkers(mapElm) {
  return JSON.parse(mapElm.dataset.markers);
}

/** Configurer la Map */
function configMap(mapElm) {
  const mapStyles = mapElm.dataset.styles ? JSON.parse(mapElm.dataset.styles) : null;
  return new google.maps.Map(mapElm, {
    center: JSON.parse(mapElm.dataset.center),
    zoom: parseInt(JSON.parse(mapElm.dataset.zoom)),
    styles: mapStyles,
  });
}

/** Créer l'icône du marker */
function setMarkerIcon(markerData) {
  if (!markerData.icon) {
    return false;
  }
  return {
    url: markerData.icon.url,
    scaledSize: new google.maps.Size(markerData.icon.width, markerData.icon.height),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(markerData.icon.width / 2, markerData.icon.height)
  };
}

/** Création un marqueur */
function setMarker(markerData, map) {

  const icon = setMarkerIcon(markerData)

  /** créer la div parente */
  const bulleMap = document.createElement('div');
  bulleMap.classList.add('bulle-map');

  /** Créer un élément <a> pour si jamais il y a un lien */
  const link = document.createElement('a');
  link.classList.add('link-unstyled');

  /** Créer un wrapper qui va contenu les éléments */
  const infosWrapper = document.createElement('div');
  infosWrapper.classList.add('infos-wrapper');

  /**
   * On rassemble tout les élément dans l'élément <a> si c'est un lien
   * ou directement dans le wrapper si ce n'est pas un lien
   * */
  if (markerData.link) {
    link.href = markerData.link;
    bulleMap.appendChild(link);
    link.appendChild(infosWrapper);
  } else {
    bulleMap.appendChild(infosWrapper);
  }

  /** On rajoute le contenu du marqueur */
  infosWrapper.innerHTML = markerData.content;

  const infoWindow = new google.maps.InfoWindow({
    content: bulleMap.outerHTML,
  });

  markerData.map = map;
  if (icon !== false) {
    markerData.icon = icon;
  }

  const marker = new google.maps.Marker(markerData);

  marker.addListener('click', () => {
    /** Fermer l'InfoWindow précédemment ouverte, si elle existe */
    if (mapOpenInfoWindow) {
      mapOpenInfoWindow.close();
    }
    /** Ouvrir la nouvelle InfoWindow */
    infoWindow.open(map, marker);
    /** Stocker la nouvelle InfoWindow comme étant l'InfoWindow actuellement ouverte */
    mapOpenInfoWindow = infoWindow;
  });
  marker.markerData = markerData;
  return marker;
}

/** Créer les marqueurs */
function setMarkers(map, mapElm) {
  const markersData = getMapMarkers(mapElm);
  const markers = markersData.map(markerData => {
    return setMarker(markerData, map);
  });

  // Si il y a plus d'un marker, ajuster automatiquement le zoom et le centre
  if (markers.length > 1) {
    const bounds = new google.maps.LatLngBounds();

    // Ajouter chaque marker à l'objet bounds
    markers.forEach(marker => {
      bounds.extend(marker.getPosition());
    });

    // Ajuster la carte pour afficher tous les markers avec un petit padding
    // pour éviter que les markers soient trop près des bords
    const padding = {top: 30, right: 30, bottom: 30, left: 30};
    map.fitBounds(bounds, padding);
  } else {
    map.center = markers[0].getPosition();
  }

  return markers;
}
